export const tvs = [
  {
    id: "tv-1",
    type: "tv",
    title: "长夜将明",
    image: "https://readdy.ai/api/search-image?query=suspense%20tv%20series%20poster%20of%20a%20silhouetted%20figure%20before%20a%20foggy%20city%20dawn%2C%20deep%20navy%20tones%20with%20a%20thin%20orange%20horizon%20glow%2C%20minimal%20dark%20mysterious%20background%2C%20dramatic%20lighting%2C%20professional%20series%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=tv-01-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20foggy%20city%20skyline%20at%20first%20light%20with%20deep%20blue%20mist%20and%20a%20warm%20orange%20sunrise%20breaking%20through%2C%20mysterious%20moody%20color%20grading%2C%20wide%20atmospheric%20composition%2C%20highly%20detailed%20cinematography&width=1600&height=900&seq=tv-01-cover&orientation=landscape",
    rating: 9.0,
    year: "2026",
    releaseDate: "2026-05-16",
    region: "中国大陆",
    genres: ["悬疑", "刑侦"],
    cast: "沈越、顾清",
    director: "赵衡",
    episodes: 24,
    seasons: 1,
    status: "全季完结",
    summary: "一桩跨越十二年的悬案，将三个家庭的命运牢牢捆在一起。",
    content: [
      "十二年前的一起失踪案始终悬而未决，当年的办案警官退休前留下了一份未曾公开的卷宗。",
      "年轻刑警沈越接手后，发现所有线索都指向一个早已被遗忘的名字，而真相的代价远超想象。",
      "全剧以冷色调影像与缜密的推理解构人性，被称为年度悬疑黑马。",
    ],
    tags: ["悬疑", "完结", "高分剧"],
  },
  {
    id: "tv-2",
    type: "tv",
    title: "都市繁花",
    image: "https://readdy.ai/api/search-image?query=urban%20drama%20tv%20series%20poster%20of%20elegant%20city%20women%20silhouettes%20among%20glowing%20skyscrapers%20at%20night%2C%20deep%20navy%20background%20with%20warm%20orange%20window%20lights%2C%20minimal%20chic%20composition%2C%20cinematic%20lighting%2C%20professional%20series%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=tv-02-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=glamorous%20modern%20city%20at%20night%20with%20glowing%20glass%20towers%20and%20warm%20orange%20streets%2C%20deep%20blue%20night%20tones%2C%20cinematic%20urban%20color%20grading%2C%20wide%20elegant%20composition%2C%20highly%20detailed%20cityscape%20photography&width=1600&height=900&seq=tv-02-cover&orientation=landscape",
    rating: 8.4,
    year: "2026",
    releaseDate: "2026-08-08",
    region: "中国大陆",
    genres: ["都市", "情感"],
    cast: "林薇、周慕、陈嘉",
    director: "孙可",
    episodes: 36,
    seasons: 1,
    status: "正在热播",
    summary: "三位都市女性在职场与情感中浮沉，寻找属于自己的绽放方式。",
    content: [
      "林薇、周慕与陈嘉是三个性格迥异的都市女性，她们在各自的赛道上奔跑，也都在生活的浪潮里挣扎。",
      "从职场博弈到亲密关系，她们彼此扶持、也不断碰撞，在一次次选择中重新认识自己。",
      "剧集以精致的都市美学与细腻的情感刻画，勾勒出当代女性的多面人生。",
    ],
    tags: ["都市", "热播", "女性群像"],
  },
  {
    id: "tv-3",
    type: "tv",
    title: "山河故人录",
    image: "https://readdy.ai/api/search-image?query=epic%20chinese%20historical%20drama%20poster%20with%20a%20lone%20swordsman%20on%20a%20cliff%20overlooking%20misty%20mountains%2C%20deep%20navy%20and%20ink%20tones%20with%20warm%20orange%20sunset%2C%20minimal%20atmospheric%20background%2C%20dramatic%20lighting%2C%20professional%20series%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=tv-03-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=ink%20wash%20ancient%20chinese%20mountains%20at%20sunset%20with%20deep%20blue%20mist%20and%20warm%20orange%20sky%2C%20lone%20figure%20on%20a%20ridge%2C%20cinematic%20epic%20color%20grading%2C%20wide%20majestic%20composition%2C%20highly%20detailed%20landscape%20painting&width=1600&height=900&seq=tv-03-cover&orientation=landscape",
    rating: 8.6,
    year: "2025",
    releaseDate: "2025-09-09",
    region: "中国大陆",
    genres: ["古装", "历史"],
    cast: "萧衍、苏芷",
    director: "顾西洲",
    episodes: 48,
    seasons: 1,
    status: "全季完结",
    summary: "乱世之中，一介布衣如何在权谋与家国之间坚守本心。",
    content: [
      "王朝末年，战火四起，出身寒门的萧衍因一封旧信被卷入朝堂纷争。",
      "在乱世权谋的漩涡中，他一边守护心中的道义，一边直面最残酷的取舍。",
      "剧集考究的服化道与厚重的人文气质，让观众得以重温一段荡气回肠的家国往事。",
    ],
    tags: ["古装", "历史", "完结"],
  },
  {
    id: "tv-4",
    type: "tv",
    title: "破晓之城",
    image: "https://readdy.ai/api/search-image?query=crime%20drama%20tv%20series%20poster%20of%20a%20detective%20badge%20and%20city%20lights%20in%20heavy%20rain%2C%20deep%20navy%20night%20tones%20with%20warm%20orange%20reflections%2C%20minimal%20gritty%20background%2C%20dramatic%20lighting%2C%20professional%20series%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=tv-04-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=rain%20soaked%20city%20at%20dawn%20with%20deep%20blue%20fog%20and%20warm%20orange%20street%20lights%20reflecting%20on%20wet%20asphalt%2C%20cinematic%20crime%20color%20grading%2C%20wide%20moody%20composition%2C%20highly%20detailed%20urban%20photography&width=1600&height=900&seq=tv-04-cover&orientation=landscape",
    rating: 8.1,
    year: "2026",
    releaseDate: "2026-07-01",
    region: "中国大陆",
    genres: ["犯罪", "悬疑"],
    cast: "雷震、柳青",
    director: "韩默",
    episodes: 30,
    seasons: 1,
    status: "正在热播",
    summary: "一座城市的黎明之前，总有人在暗处与罪恶赛跑。",
    content: [
      "刑侦队长雷震带领的专案组，正追查一个组织严密的犯罪网络。",
      "随着调查不断深入，他们发现案件的源头竟与警队内部有着千丝万缕的联系。",
      "剧集以快节奏的叙事与真实感十足的现场感，呈现了一场关于光明与黑暗的较量。",
    ],
    tags: ["犯罪", "热播", "刑侦"],
  },
  {
    id: "tv-5",
    type: "tv",
    title: "医者仁心",
    image: "https://readdy.ai/api/search-image?query=medical%20drama%20tv%20series%20poster%20of%20a%20surgeon%20in%20a%20bright%20operating%20theatre%2C%20deep%20navy%20tones%20with%20warm%20orange%20instrument%20light%2C%20minimal%20clean%20clinical%20background%2C%20dramatic%20lighting%2C%20professional%20series%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=tv-05-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=modern%20hospital%20corridor%20at%20night%20with%20deep%20blue%20shadows%20and%20warm%20orange%20light%20from%20a%20doorway%2C%20cinematic%20clinical%20color%20grading%2C%20wide%20clean%20composition%2C%20highly%20detailed%20interior%20photography&width=1600&height=900&seq=tv-05-cover&orientation=landscape",
    rating: 8.5,
    year: "2025",
    releaseDate: "2025-11-20",
    region: "中国大陆",
    genres: ["医疗", "剧情"],
    cast: "纪南、白露、韩野",
    director: "章亦",
    episodes: 40,
    seasons: 1,
    status: "全季完结",
    summary: "在生死之间，一群医者用专业与温柔守护每一个普通的生命。",
    content: [
      "急诊科医生纪南每天面对的是最真实的人间百态，每一次抢救都是一场与时间的拔河。",
      "在高压的工作中，她与同事们彼此支撑，也不断直面职业理想与现实的碰撞。",
      "剧集以扎实的医疗细节和温暖的人文关怀，致敬每一位默默坚守的医者。",
    ],
    tags: ["医疗", "剧情", "完结"],
  },
  {
    id: "tv-6",
    type: "tv",
    title: "星际商途",
    image: "https://readdy.ai/api/search-image?query=space%20sci-fi%20tv%20series%20poster%20of%20a%20sleek%20trading%20starship%20approaching%20a%20ringed%20planet%2C%20deep%20navy%20space%20with%20warm%20orange%20engine%20trails%2C%20minimal%20futuristic%20background%2C%20dramatic%20lighting%2C%20professional%20series%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=tv-06-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20space%20port%20with%20many%20sleek%20starships%20near%20a%20ringed%20planet%20in%20deep%20blue%20nebula%2C%20warm%20orange%20thruster%20lights%2C%20cinematic%20sci-fi%20color%20grading%2C%20wide%20grand%20composition%2C%20highly%20detailed%20concept%20art&width=1600&height=900&seq=tv-06-cover&orientation=landscape",
    rating: 8.3,
    year: "2026",
    releaseDate: "2026-06-05",
    region: "中国大陆",
    genres: ["科幻", "商战"],
    cast: "慕容、江离",
    director: "罗砚",
    episodes: 32,
    seasons: 2,
    status: "正在热播",
    summary: "在星际贸易时代，一个小商人如何用智慧与胆识撬动整个星域格局。",
    content: [
      "星际贸易时代，年轻的商人慕容带着一艘老旧货船闯荡星域，梦想建立自己的商业版图。",
      "在利益与背叛交织的商战中，他必须学会在规则与底线之间找到生存的缝隙。",
      "剧集将商战博弈搬上星际舞台，用宏大的世界观讲述了一段关于野心与坚守的传奇。",
    ],
    tags: ["科幻", "热播", "商战"],
  },
];